import { Link } from 'react-router-dom';
import { sportsCategories, liveMatches, upcomingMatches, articles, promotions, platformStats } from '@/mocks/data';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'bb体育',
  url: 'https://www.bbtiyu.com/',
  description: 'bb体育是您信赖的专业体育平台，涵盖足球、篮球、网球等热门赛事投注与实时直播。',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-6666',
    email: 'service@bbtiyu.com',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  url: 'https://www.bbtiyu.com/',
  name: 'bb体育 - 专业体育赛事投注与直播平台',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.bbtiyu.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>

      <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=dynamic%20sports%20stadium%20night%20atmosphere%20with%20dramatic%20stadium%20lights%20flooding%20the%20field%20green%20grass%20soccer%20pitch%20professional%20sports%20photography%20energy%20and%20excitement%20warm%20golden%20and%20red%20tones%20wide%20angle%20cinematic%20composition&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="bb体育 - 专业体育赛事投注与直播平台"
          title="bb体育 专业体育赛事投注与直播平台"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
        <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4">
            专业体育赛事<strong className="text-primary-400">投注</strong>与<strong className="text-primary-400">直播</strong>平台
          </h1>
          <p className="text-sm md:text-base text-white/80 max-w-2xl mb-8">
            bb体育涵盖足球、篮球、网球等热门赛事，提供最新赔率、海量赛事数据及安全稳定的投注环境，注册即享专属优惠
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3">
            <Link
              to="/about"
              className="px-8 py-3 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap text-sm"
            >
              立即注册
            </Link>
            <Link
              to="/category/football"
              className="px-8 py-3 border border-white/40 text-white font-medium rounded-md hover:bg-white/10 transition-colors whitespace-nowrap text-sm"
            >
              查看赛事
            </Link>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900">
              <i className="ri-live-line text-primary-500 mr-2"></i>
              实时赛事直播
            </h2>
            <Link to="/category/football" className="text-xs text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1">
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {liveMatches.slice(0, 6).map((match) => (
              <div
                key={match.id}
                className="bg-background-100 rounded-lg p-4 md:p-5 border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs text-foreground-500">{match.league}</span>
                  {match.isLive ? (
                    <span className="flex items-center gap-1 text-xs text-primary-500 font-medium">
                      <span className="w-1.5 h-1.5 bg-primary-500 rounded-full animate-pulse"></span>
                      直播中
                    </span>
                  ) : (
                    <span className="text-xs text-foreground-400">{match.minute}</span>
                  )}
                </div>
                <div className="flex items-center justify-between mb-3">
                  <div className="flex flex-col items-center gap-2 flex-1">
                    <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-background-200 overflow-hidden flex items-center justify-center">
                      <img src={match.homeLogo} alt={match.homeTeam} className="w-full h-full object-cover" />
                    </div>
                    <span className="text-xs text-foreground-700 text-center whitespace-nowrap">{match.homeTeam}</span>
                  </div>
                  <div className="flex flex-col items-center px-3 md:px-4">
                    <span className="text-xl md:text-2xl font-heading font-bold text-foreground-900 whitespace-nowrap">
                      {match.score}
                    </span>
                    {match.isLive && (
                      <span className="text-xs text-primary-500">{match.minute}</span>
                    )}
                  </div>
                  <div className="flex flex-col items-center gap-2 flex-1">
                    <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-background-200 overflow-hidden flex items-center justify-center">
                      <img src={match.awayLogo} alt={match.awayTeam} className="w-full h-full object-cover" />
                    </div>
                    <span className="text-xs text-foreground-700 text-center whitespace-nowrap">{match.awayTeam}</span>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  {match.odds.home !== undefined && (
                    <>
                      <button className="flex-1 py-1.5 text-xs bg-background-200 hover:bg-primary-100 rounded transition-colors whitespace-nowrap text-center">
                        <span className="block text-foreground-400">主胜</span>
                        <span className="block font-semibold text-foreground-800">{match.odds.home}</span>
                      </button>
                      {match.odds.draw !== undefined && (
                        <button className="flex-1 py-1.5 text-xs bg-background-200 hover:bg-primary-100 rounded transition-colors whitespace-nowrap text-center">
                          <span className="block text-foreground-400">平</span>
                          <span className="block font-semibold text-foreground-800">{match.odds.draw}</span>
                        </button>
                      )}
                      <button className="flex-1 py-1.5 text-xs bg-background-200 hover:bg-primary-100 rounded transition-colors whitespace-nowrap text-center">
                        <span className="block text-foreground-400">客胜</span>
                        <span className="block font-semibold text-foreground-800">{match.odds.away}</span>
                      </button>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 text-center mb-8">
            热门赛事分类
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
            {sportsCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="bg-background-50 rounded-lg p-4 md:p-5 border border-background-200/70 hover:border-primary-300 hover:shadow-sm transition-all text-center group"
              >
                <div className="w-11 h-11 md:w-12 md:h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                  <i className={`${cat.icon} text-base md:text-lg text-primary-500`}></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 mb-1">{cat.name}</h3>
                <p className="text-xs text-foreground-500">{cat.matchCount}场赛事</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900">
              <i className="ri-fire-line text-accent-500 mr-2"></i>
              即将开赛
            </h2>
            <Link to="/category/football" className="text-xs text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1">
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
            <div className="divide-y divide-background-200/70">
              {upcomingMatches.map((match) => (
                <div key={match.id} className="flex items-center justify-between px-4 py-3 hover:bg-background-200/40 transition-colors">
                  <div className="flex items-center gap-3 flex-1 min-w-0">
                    <span className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded whitespace-nowrap">{match.league}</span>
                    <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{match.homeTeam}</span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">VS</span>
                    <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{match.awayTeam}</span>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="text-xs text-foreground-500 whitespace-nowrap hidden sm:block">{match.time}</span>
                    <div className="flex items-center gap-1">
                      {match.odds.home !== undefined && (
                        <button className="px-3 py-1 text-xs bg-background-200 hover:bg-primary-100 rounded transition-colors whitespace-nowrap">
                          <span className="font-semibold text-foreground-700">{match.odds.home}</span>
                        </button>
                      )}
                      {match.odds.draw !== undefined && (
                        <button className="px-3 py-1 text-xs bg-background-200 hover:bg-primary-100 rounded transition-colors whitespace-nowrap">
                          <span className="font-semibold text-foreground-700">{match.odds.draw}</span>
                        </button>
                      )}
                      <button className="px-3 py-1 text-xs bg-background-200 hover:bg-primary-100 rounded transition-colors whitespace-nowrap">
                        <span className="font-semibold text-foreground-700">{match.odds.away}</span>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 text-center mb-8">
            专属优惠活动
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {promotions.map((promo) => (
              <Link
                key={promo.id}
                to={`/article/${promo.id === 'promo-1' ? 'article-4' : promo.id === 'promo-2' ? 'article-7' : 'article-4'}`}
                className="bg-background-50 rounded-lg p-5 border border-background-200/70 hover:border-primary-300 transition-all group"
              >
                <div className={`w-10 h-10 rounded-full bg-${promo.color}-100 flex items-center justify-center mb-3 group-hover:bg-${promo.color}-200 transition-colors`}>
                  <i className={`${promo.icon} text-lg text-${promo.color}-500`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">{promo.title}</h3>
                <p className="text-xs text-foreground-500">{promo.description}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-primary-500">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {platformStats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="w-10 h-10 mx-auto mb-2 rounded-full bg-white/20 flex items-center justify-center">
                  <i className={`${stat.icon} text-lg text-white`}></i>
                </div>
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.value}</div>
                <div className="text-xs text-white/70 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900">
              <i className="ri-article-line text-primary-500 mr-2"></i>
              体育资讯
            </h2>
            <Link to="/category/football" className="text-xs text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1">
              更多资讯 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {articles.slice(0, 6).map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all group"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    title={`${article.title} - bb体育`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-2 py-0.5 bg-primary-500 text-white text-xs rounded">
                    {article.category === 'football' ? '足球' : article.category === 'basketball' ? '篮球' : article.category === 'tennis' ? '网球' : article.category === 'esports' ? '电竞' : article.category === 'promotions' ? '优惠' : '指南'}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-medium text-foreground-800 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{article.excerpt}</p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span>{article.date}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            加入<strong className="text-primary-500">bb体育</strong>，开启竞技之旅
          </h2>
          <p className="text-sm text-foreground-600 mb-8">
            注册即享888元专属礼包，海量赛事、实时赔率、安全投注，尽在bb体育
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/about"
              className="px-8 py-3 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap text-sm"
            >
              立即注册
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 border border-background-300 text-foreground-700 font-medium rounded-md hover:bg-background-200 transition-colors whitespace-nowrap text-sm"
            >
              了解更多
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}